import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { WarnIcon } from '~/icons';
import { colors } from '~/styles/colors';
import { BadgeContainer } from './styles';

export function PendingBadge(): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <BadgeContainer data-tip data-for="tooltip-pending-programming">
        <WarnIcon color={colors.brand.primary.base} />
        <span>{t('programacaoPendente')}</span>
      </BadgeContainer>
      <ReactTooltip
        id="tooltip-pending-programming"
        place="bottom"
        effect="solid"
        delayHide={100}
        textColor="#000000"
        border
        backgroundColor="rgba(256, 256, 256, 1)"
      >
        {t('programacaoEnviadaDispositivoOffline')}
      </ReactTooltip>
    </>
  );
}
